export class UserId {
  private constructor(private readonly value: number) {
    if (value <= 0) {
      throw new Error('User ID must be greater than 0');
    }
  }

  /**
   * Crea un nuevo UserId con validaciones
   */
  static create(id: number): UserId {
    return new UserId(id);
  }

  /**
   * Reconstruye un UserId desde persistencia (sin validaciones)
   * Usar solo cuando el valor ya fue validado previamente
   */
  static fromValue(id: number): UserId {
    const userId = Object.create(UserId.prototype);
    (userId as any).value = id;
    return userId;
  }

  getValue(): number {
    return this.value;
  }

  equals(other: UserId): boolean {
    return this.value === other.value;
  }
}
